<template>
    <div>
        <article v-if="gallery && hasGallery && isNotProductPage" class="page-gallery">
            <files-gallery                     
                    :settings="page.settings"
                    :listing="page.files" />
            <slot></slot>
        </article>        
        <article class="page-body">            
            <section v-html="page.body" />
            <slot></slot>
        </article>
    </div>
</template>

<script>
import FilesGallery from '@/features/files/components/public/FilesGallery'
import { pagesComputed } from '../../store'
export default {
    components: {
		FilesGallery
	},
    props: {
        slug: {
            type: String,
            required: true
        },
        gallery: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...pagesComputed,
        page() {            
            return this.pages.find(temp => temp.slug == this.slug)
        },
        hasGallery() {
            return this.page && this.page.files.length > 0
        },
        isNotProductPage() {
            try { return this.page.settings.productList ? false : true }
            catch (e) { return true }
        }
    }
}
</script>